import React, { useEffect, createElement, Component } from 'react';
import { AlertTriangle, ArrowRight, BookOpen, CheckCircle2, ClipboardCheck, Compass, Download, Droplets, FileCheck, Flame, Gift, Hammer, Map, PenTool, Shield, ShieldCheck, Sun, Thermometer, Truck, Wrench, Zap, BoxIcon } from 'lucide-react';
import { PurchasePopup } from '../components/PurchasePopup';
const CHECKOUT_URL = 'https://guia-de-camperizacion.impultienda.ar/checkout';
const PRODUCT_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/oc3dMhxDVrxry9XJNvs4j3/557014a0-67c9-4202-b37a-12cc9bef2de3.png';
interface MetaPixelFunction {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  loaded?: boolean;
  push?: MetaPixelFunction;
  queue?: unknown[][];
  version?: string;
}
interface MetaPixelWindow extends Window {
  _fbq?: MetaPixelFunction;
  fbq?: MetaPixelFunction;
}
interface GuideModule {
  icon: BoxIcon;
  title: string;
  summary: string;
  items: string[];
}
const GUIDE_MODULES: GuideModule[] = [{
  icon: BookOpen,
  title: 'Parte 1: Fundamentos del proyecto',
  summary: 'El punto de partida para decidir con claridad antes de comenzar.',
  items: ['Tipos de proyecto y objetivos de uso', 'Cálculo inicial de peso y capacidad', 'Errores frecuentes y el orden correcto de las fases']
}, {
  icon: Wrench,
  title: 'Parte 2: Herramientas y materiales',
  summary: 'Un inventario funcional para invertir solo en lo necesario.',
  items: ['Herramientas esenciales y alternativas de alquiler', 'Materiales base, selladores y adhesivos', 'Cómo interpretar fichas técnicas y comparar opciones']
}, {
  icon: Truck,
  title: 'Parte 3: Elección del vehículo',
  summary: 'Criterios prácticos para elegir una base adecuada para tu proyecto.',
  items: ['Capacidad, distribución y estado general', 'Puntos clave para revisar un vehículo usado', 'Cómo alinear el vehículo con tu forma de viajar']
}, {
  icon: PenTool,
  title: 'Parte 4: Planificación y diseño interior',
  summary: 'Diseña el espacio y los sistemas antes de cortar o instalar.',
  items: ['Distribuciones funcionales y ergonomía', 'Recorridos de cables y tuberías', 'Validación del diseño a escala']
}, {
  icon: Shield,
  title: 'Parte 5: Preparación del vehículo',
  summary: 'La base que protege el proyecto y facilita el trabajo posterior.',
  items: ['Tratamiento de corrosión y sellado', 'Revisión de juntas, drenajes y cavidades', 'Preparación ordenada de superficies']
}, {
  icon: Thermometer,
  title: 'Parte 6: Aislamiento térmico y acústico',
  summary: 'Crea un interior más confortable y preparado para distintos climas.',
  items: ['Comparativa de materiales aislantes', 'Prevención de puentes térmicos y condensación', 'Aislamiento de suelo, paredes y techo']
}, {
  icon: Droplets,
  title: 'Parte 7: Sistema de agua',
  summary: 'Planifica un circuito eficiente para agua limpia, caliente y residual.',
  items: ['Dimensionamiento de depósitos y autonomía', 'Bombas, conexiones y tuberías', 'Gestión responsable de aguas residuales']
}, {
  icon: Flame,
  title: 'Parte 8: Gas y seguridad',
  summary: 'Principios para entender el sistema y preparar conversaciones con profesionales.',
  items: ['Componentes, ventilación y ubicación segura', 'Puntos de control y prueba de estanqueidad', 'Cuándo detenerse y recurrir a un profesional certificado']
}, {
  icon: Zap,
  title: 'Parte 9: Sistema eléctrico',
  summary: 'Comprende las bases de un sistema de 12 V organizado y protegido.',
  items: ['Consumo diario y dimensionamiento', 'Baterías, cableado, fusibles e inversor', 'Buenas prácticas de protección y diagnóstico']
}, {
  icon: Sun,
  title: 'Parte 10: Energía solar',
  summary: 'Añade autonomía con un sistema solar pensado para tu consumo.',
  items: ['Cálculo de paneles y banco de baterías', 'Controladores y configuración orientativa', 'Fijación, sellado y monitoreo']
}, {
  icon: Thermometer,
  title: 'Parte 11: Climatización y ventilación',
  summary: 'Elige soluciones de confort según el uso, el clima y el espacio disponible.',
  items: ['Alternativas de calefacción y ventilación', 'Cálculo orientativo de potencia', 'Control de humedad y ventilación cruzada']
}, {
  icon: Hammer,
  title: 'Parte 12: Construcción interior',
  summary: 'Convierte el espacio en un hogar funcional y resistente al movimiento.',
  items: ['Muebles, cocina, cama y almacenamiento', 'Soluciones compactas para baño', 'Fijaciones y materiales para uso en carretera']
}, {
  icon: PenTool,
  title: 'Parte 13: Terminaciones',
  summary: 'Los detalles que hacen que el interior se sienta terminado y duradero.',
  items: ['Suelos, revestimientos y techo', 'Iluminación LED de bajo consumo', 'Acabados resistentes a la humedad y vibración']
}, {
  icon: FileCheck,
  title: 'Parte 14: Requisitos legales',
  summary: 'Una guía para preparar tu proyecto antes de circular.',
  items: ['Documentación y revisiones habituales', 'Cómo verificar requisitos locales vigentes', 'La importancia de asesorarte con especialistas acreditados']
}, {
  icon: Map,
  title: 'Parte 15: Pruebas y primer viaje',
  summary: 'Valida cada sistema antes de iniciar una ruta más larga.',
  items: ['Secuencia de pruebas por sistema', 'Qué observar durante una salida de prueba', 'Correcciones y ajustes iniciales']
}, {
  icon: ClipboardCheck,
  title: 'Parte 16: Mantenimiento',
  summary: 'Una rutina simple para cuidar tu camper a lo largo del tiempo.',
  items: ['Revisiones periódicas de los sistemas principales', 'Preparación para viajes largos', 'Herramientas y repuestos básicos a bordo']
}];
const BONUSES = [{
  title: 'Lista maestra de materiales',
  description: 'Una lista organizada por fases para preparar tus compras, comparar opciones y estimar tu proyecto con mayor claridad.'
}, {
  title: 'Tablas eléctricas de referencia',
  description: 'Tablas prácticas de consumo, fusibles, cableado y estado de baterías para consultar durante la planificación.'
}, {
  title: 'Calculadora solar paso a paso',
  description: 'Ejemplos y una plantilla de cálculo para estimar paneles, baterías y controlador según tu consumo.'
}, {
  title: 'Checklists de construcción',
  description: 'Listas imprimibles para seguir el avance de cada fase sin olvidar pasos importantes.'
}];
export function SalesPage() {
  useEffect(() => {
    const pixelTimer = window.setTimeout(() => {
      initializeMetaPixel();
    }, 3000);
    return () => window.clearTimeout(pixelTimer);
  }, []);
  const scrollToCheckout = () => {
    document.getElementById('purchase-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full bg-stone-50 font-sans text-stone-800 selection:bg-amber-200 selection:text-stone-950" data-id="element-18">
      <PurchasePopup data-id="element-19" />

      <div className="bg-stone-950 px-4 py-3 text-center text-xs font-semibold tracking-wide text-stone-100 md:text-sm" data-id="element-20">
        PARA QUIEN QUIERE CONVERTIR SU VEHÍCULO EN UN HOGAR Y NECESITA UN PLAN
        CLARO PARA EMPEZAR
      </div>

      <header className="mx-auto max-w-5xl px-4 pb-10 pt-8 text-center md:pb-14 md:pt-12" data-id="element-21">
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.16em] text-amber-700 md:text-sm" data-id="element-22">
          Guía Maestra de Camperización Completa
        </p>
        <h1 className="mx-auto mb-5 max-w-4xl text-4xl font-extrabold leading-tight text-stone-950 md:text-6xl" data-id="element-23">
          Construye tu camper con un sistema claro, desde el vehículo vacío
          hasta tu primer viaje.
        </h1>
        <p className="mx-auto mb-7 max-w-2xl text-base leading-relaxed text-stone-600 md:text-xl" data-id="element-24">
          Una ruta paso a paso para planificar, construir y revisar cada etapa
          con más seguridad, orden y confianza.
        </p>

        <button type="button" onClick={scrollToCheckout} className="group mx-auto mb-6 block w-full max-w-xl rounded-2xl focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-300" aria-label="Ir a la sección de compra de la Guía Maestra" data-id="element-25">
          <img src={PRODUCT_IMAGE_URL} alt="Mockup de la Guía Maestra de Camperización Completa" className="mx-auto max-h-[520px] w-auto max-w-full object-contain transition-transform duration-300 group-hover:scale-[1.015]" loading="eager" data-id="element-26" />
        </button>

        <p className="mb-5 text-xs font-bold uppercase tracking-wide text-stone-500 md:text-sm" data-id="element-27">
          16 partes + recursos prácticos + 4 bonos · acceso digital inmediato
        </p>

        <ul className="mx-auto mb-7 max-w-2xl space-y-3 text-left text-sm text-stone-700 md:text-base" data-id="element-28">
          {['Un proceso guiado para pasar de la idea a un proyecto organizado.', 'Planificación, agua, electricidad, energía solar, mobiliario y más.', 'Planos de referencia, diagramas solares y soluciones para imprevistos en ruta.', 'Enfoque general para que adaptes cada decisión a tu vehículo y normativa local.'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-29">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-30" />
              <span data-id="element-31">{item}</span>
            </li>)}
        </ul>

        <button type="button" onClick={scrollToCheckout} className="mx-auto flex w-full max-w-xl items-center justify-center gap-2 rounded-xl bg-emerald-600 px-6 py-4 text-base font-extrabold text-white shadow-[0_5px_0_rgb(4,120,87)] transition hover:translate-y-0.5 hover:bg-emerald-500 hover:shadow-[0_3px_0_rgb(4,120,87)] focus:outline-none focus-visible:ring-4 focus-visible:ring-emerald-300 md:text-lg" data-id="element-32">
          QUIERO LA GUÍA MAESTRA POR US$27
          <ArrowRight className="h-5 w-5" aria-hidden="true" data-id="element-33" />
        </button>
        <p className="mt-3 text-sm font-medium text-stone-500" data-id="element-34">
          Pago único de US$27 · acceso inmediato
        </p>
      </header>

      <main data-id="element-35">
        <section className="bg-stone-950 px-4 py-16 text-stone-300 md:py-20" data-id="element-36">
          <div className="mx-auto max-w-3xl space-y-6 text-lg leading-relaxed" data-id="element-37">
            <h2 className="text-3xl font-bold leading-tight text-white md:text-4xl" data-id="element-38">
              El problema no es la falta de ganas. Es no saber cuál es el
              siguiente paso.
            </h2>
            <p data-id="element-39">
              Es fácil acumular videos, consejos y listas de compras. Lo difícil
              es convertir toda esa información dispersa en un proyecto que
              avance con sentido.
            </p>
            <p data-id="element-40">
              La duda aparece al elegir el vehículo, diseñar el interior,
              calcular la electricidad o decidir qué debe instalarse primero.
              Sin un orden, cada elección puede convertirse en una corrección
              costosa más adelante.
            </p>
            <blockquote className="border-l-4 border-amber-400 py-2 pl-6 text-xl font-semibold italic text-amber-300" data-id="element-41">
              Un camper no se construye improvisando: se construye tomando
              buenas decisiones en el orden correcto.
            </blockquote>
            <p data-id="element-42">
              La Guía Maestra reúne ese proceso en una ruta clara para que
              puedas avanzar fase por fase, entendiendo qué estás haciendo y por
              qué.
            </p>
          </div>
        </section>

        <section className="bg-white px-4 py-16 md:py-20" data-id="element-43">
          <div className="mx-auto max-w-5xl" data-id="element-44">
            <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-45">
              <p className="mb-3 text-sm font-bold uppercase tracking-[0.16em] text-amber-700" data-id="element-46">
                Un proceso, no información suelta
              </p>
              <h2 className="text-3xl font-bold text-stone-950 md:text-4xl" data-id="element-47">
                Lo que frena la mayoría de los proyectos de camperización
              </h2>
            </div>
            <div className="grid gap-6 md:grid-cols-2" data-id="element-48">
              {['Consejos contradictorios que no consideran tu vehículo ni tu forma de viajar.', 'Compras prematuras que terminan generando desperdicio o retrabajo.', 'Miedo a los sistemas técnicos por no contar con explicaciones claras.', 'Diseños atractivos que no contemplan peso, seguridad o mantenimiento.'].map(item => <article key={item} className="rounded-2xl border border-stone-200 bg-stone-50 p-6" data-id="element-49">
                  <AlertTriangle className="mb-4 h-8 w-8 text-amber-500" aria-hidden="true" data-id="element-50" />
                  <p className="text-lg leading-relaxed text-stone-700" data-id="element-51">
                    {item}
                  </p>
                </article>)}
            </div>
            <div className="mt-8 rounded-2xl bg-stone-100 p-7 text-center md:p-9" data-id="element-52">
              <p className="text-xl font-bold text-stone-950" data-id="element-53">
                No necesitas saberlo todo antes de empezar. Necesitas un sistema
                para avanzar paso a paso.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-stone-900 px-4 py-16 text-stone-300 md:py-20" data-id="element-54">
          <div className="mx-auto max-w-4xl" data-id="element-55">
            <h2 className="mb-5 text-center text-3xl font-bold text-white md:text-4xl" data-id="element-56">
              La guía convierte la complejidad en una ruta práctica.
            </h2>
            <p className="mx-auto mb-10 max-w-3xl text-center text-lg leading-relaxed" data-id="element-57">
              No reemplaza el criterio de profesionales cualificados ni las
              reglas de tu país. Te ayuda a llegar a cada decisión con mejor
              contexto, mejores preguntas y un plan coherente.
            </p>
            <div className="space-y-5" data-id="element-58">
              {[['Planifica antes de construir', 'Define prioridades, distribución, presupuesto y secuencia de trabajo antes de intervenir el vehículo.'], ['Comprende cada sistema', 'Aprende los principios de agua, electricidad, energía solar, aislamiento y mobiliario con explicaciones claras.'], ['Trabaja con más seguridad', 'Identifica qué tareas requieren revisión, certificación o ejecución por parte de especialistas acreditados.']].map(([title, description]) => <article key={title} className="rounded-2xl border border-stone-700 bg-stone-800 p-6 md:p-8" data-id="element-59">
                  <h3 className="mb-2 text-xl font-bold text-amber-300" data-id="element-60">
                    {title}
                  </h3>
                  <p className="leading-relaxed" data-id="element-61">{description}</p>
                </article>)}
            </div>
            <div className="mt-10 text-center" data-id="element-62">
              <button type="button" onClick={scrollToCheckout} className="inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-600 px-7 py-4 font-extrabold text-white shadow-[0_5px_0_rgb(4,120,87)] transition hover:translate-y-0.5 hover:bg-emerald-500 hover:shadow-[0_3px_0_rgb(4,120,87)] focus:outline-none focus-visible:ring-4 focus-visible:ring-emerald-300" data-id="element-63">
                VER TODO LO QUE INCLUYE LA GUÍA
                <ArrowRight className="h-5 w-5" aria-hidden="true" data-id="element-64" />
              </button>
            </div>
          </div>
        </section>

        <section className="bg-white px-4 py-16 md:py-20" data-id="element-65">
          <div className="mx-auto max-w-5xl" data-id="element-66">
            <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-67">
              <p className="mb-3 text-sm font-bold uppercase tracking-[0.16em] text-amber-700" data-id="element-68">
                La Guía Maestra de Camperización Completa
              </p>
              <h2 className="mb-5 text-3xl font-extrabold text-stone-950 md:text-5xl" data-id="element-69">
                Todo el proceso para construir con más claridad.
              </h2>
              <p className="text-lg leading-relaxed text-stone-600" data-id="element-70">
                Un marco práctico para organizar el proyecto desde la primera
                decisión hasta las pruebas y el mantenimiento.
              </p>
            </div>
            <div className="rounded-3xl border border-stone-200 bg-stone-50 p-7 md:p-10" data-id="element-71">
              <h3 className="mb-4 text-2xl font-bold text-stone-950" data-id="element-72">
                El método de construcción secuencial
              </h3>
              <p className="mb-4 text-lg leading-relaxed text-stone-700" data-id="element-73">
                Cada fase está conectada con la siguiente. Diseñas antes de
                instalar, instalas antes de cerrar y pruebas antes de viajar.
                Así reduces cambios innecesarios y puedes tomar decisiones con
                una visión completa.
              </p>
              <p className="text-lg leading-relaxed text-stone-700" data-id="element-74">
                La guía te acompaña para entender el recorrido; para
                instalaciones de gas, electricidad, modificaciones estructurales
                y homologación, consulta siempre las normas locales y
                profesionales certificados.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-stone-100 px-4 py-16 md:py-20" data-id="element-75">
          <div className="mx-auto max-w-6xl" data-id="element-76">
            <div className="mb-12 text-center" data-id="element-77">
              <h2 className="mb-3 text-3xl font-bold text-stone-950 md:text-4xl" data-id="element-78">
                Qué encontrarás dentro
              </h2>
              <p className="text-lg text-stone-600" data-id="element-79">
                16 partes diseñadas para guiarte desde el vehículo vacío hasta
                el primer viaje.
              </p>
            </div>
            <div className="grid gap-6 md:grid-cols-2" data-id="element-80">
              {GUIDE_MODULES.map(module => {
              const Icon = module.icon;
              return <article key={module.title} className="rounded-2xl border border-stone-200 bg-white p-6 shadow-sm md:p-7" data-id="element-81">
                    <div className="mb-4 flex items-start gap-3" data-id="element-82">
                      <div className="rounded-xl bg-amber-100 p-2.5 text-amber-700" data-id="element-83">
                        <Icon className="h-6 w-6" aria-hidden="true" data-id="element-84" />
                      </div>
                      <h3 className="pt-1 text-xl font-bold leading-snug text-stone-950" data-id="element-85">
                        {module.title}
                      </h3>
                    </div>
                    <p className="mb-4 leading-relaxed text-stone-600" data-id="element-86">
                      {module.summary}
                    </p>
                    <ul className="space-y-2 text-sm leading-relaxed text-stone-700" data-id="element-87">
                      {module.items.map(item => <li key={item} className="flex gap-2" data-id="element-88">
                          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-89" />
                          <span data-id="element-90">{item}</span>
                        </li>)}
                    </ul>
                  </article>;
            })}
            </div>
          </div>
        </section>

        <section className="bg-stone-950 px-4 py-16 text-stone-200 md:py-20" data-id="element-91">
          <div className="mx-auto max-w-5xl" data-id="element-92">
            <div className="mb-12 text-center" data-id="element-93">
              <Gift className="mx-auto mb-5 h-14 w-14 text-amber-400" aria-hidden="true" data-id="element-94" />
              <h2 className="mb-3 text-3xl font-bold text-white md:text-4xl" data-id="element-95">
                Cuatro bonos incluidos
              </h2>
              <p className="text-lg text-stone-400" data-id="element-96">
                Recursos adicionales para convertir el plan en acciones
                concretas.
              </p>
            </div>
            <div className="grid gap-5 md:grid-cols-2" data-id="element-97">
              {BONUSES.map((bonus, index) => <article key={bonus.title} className="rounded-2xl border border-stone-700 bg-stone-900 p-6" data-id="element-98">
                  <p className="mb-3 text-sm font-bold uppercase tracking-wider text-amber-300" data-id="element-99">
                    Bono {index + 1}
                  </p>
                  <h3 className="mb-3 text-xl font-bold text-white" data-id="element-100">
                    {bonus.title}
                  </h3>
                  <p className="leading-relaxed text-stone-400" data-id="element-101">
                    {bonus.description}
                  </p>
                </article>)}
            </div>
          </div>
        </section>

        <section className="bg-amber-500 px-4 py-16 text-stone-950 md:py-20" data-id="element-102">
          <div className="mx-auto max-w-3xl" data-id="element-103">
            <h2 className="mb-9 text-center text-3xl font-extrabold md:text-4xl" data-id="element-104">
              Esta guía es para ti si...
            </h2>
            <ul className="space-y-4 text-lg font-medium" data-id="element-105">
              {['Tienes un vehículo y quieres comenzar con un plan realista.', 'Quieres construir por tu cuenta y entender cada fase antes de ejecutarla.', 'Buscas explicaciones claras para sistemas que parecen complejos.', 'Quieres diseñar un espacio funcional, seguro y preparado para viajar.', 'Necesitas saber qué aspectos deben validarse con normativa y profesionales locales.'].map(item => <li key={item} className="flex items-start gap-4 rounded-xl bg-amber-400/40 p-4" data-id="element-106">
                  <CheckCircle2 className="mt-0.5 h-6 w-6 shrink-0" aria-hidden="true" data-id="element-107" />
                  <span data-id="element-108">{item}</span>
                </li>)}
            </ul>
          </div>
        </section>

        <section className="bg-white px-4 py-16 md:py-20" data-id="element-109">
          <div className="mx-auto max-w-4xl rounded-3xl border border-stone-200 bg-stone-50 p-7 md:p-10" data-id="element-110">
            <div className="mx-auto max-w-3xl text-center" data-id="element-111">
              <Compass className="mx-auto mb-5 h-12 w-12 text-amber-600" aria-hidden="true" data-id="element-112" />
              <h2 className="mb-4 text-3xl font-bold text-stone-950" data-id="element-113">
                Un recurso para tomar mejores decisiones en ruta.
              </h2>
              <p className="text-lg leading-relaxed text-stone-600" data-id="element-114">
                Desde la distribución inicial hasta el mantenimiento, tendrás
                una visión ordenada para adaptar a tu vehículo, presupuesto,
                experiencia y condiciones de uso.
              </p>
            </div>
          </div>
        </section>

        <section id="purchase-section" className="scroll-mt-8 bg-white px-4 py-16 md:py-20" data-id="element-115">
          <div className="mx-auto max-w-4xl" data-id="element-116">
            <div className="relative overflow-hidden rounded-3xl bg-stone-950 p-6 text-center md:p-12" data-id="element-117">
              <div className="mx-auto mb-8 inline-flex items-center gap-2 rounded-full bg-amber-400 px-4 py-2 text-sm font-bold text-stone-950" data-id="element-118">
                <ShieldCheck className="h-4 w-4" aria-hidden="true" data-id="element-119" />
                ACCESO DIGITAL INMEDIATO
              </div>
              <h2 className="mb-3 text-3xl font-bold text-white md:text-4xl" data-id="element-120">
                Guía Maestra de Camperización Completa
              </h2>
              <p className="mx-auto mb-8 max-w-2xl text-base leading-relaxed text-stone-300 md:text-lg" data-id="element-121">
                Una guía digital con 16 partes, recursos de planificación,
                planos y medidas de referencia, guía solar con diagramas y
                configuración, manual para imprevistos en ruta y cuatro bonos
                prácticos.
              </p>

              <div className="mx-auto mb-8 max-w-2xl rounded-2xl border-2 border-cyan-400 bg-stone-900 p-6 text-left md:p-8" data-id="element-122">
                <div className="mb-6 flex flex-col gap-3 border-b border-stone-700 pb-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-123">
                  <div data-id="element-124">
                    <p className="text-sm font-bold uppercase tracking-wider text-cyan-300" data-id="element-125">
                      Oferta única
                    </p>
                    <h3 className="mt-1 text-2xl font-bold text-white" data-id="element-126">
                      Todo incluido en una sola guía
                    </h3>
                  </div>
                  <p className="text-4xl font-extrabold text-white" data-id="element-127">US$27</p>
                </div>
                <ul className="space-y-4 text-stone-200" data-id="element-128">
                  {['Guía completa de 16 partes para planificar y construir tu camper.', 'Planos maestros y medidas de referencia para distintas configuraciones.', 'Guía de energía solar con diagramas, criterios de cálculo y configuración orientativa.', 'Manual de soluciones para imprevistos habituales en ruta.', 'Lista de materiales, tablas eléctricas, calculadora solar y checklists imprimibles.'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-129">
                      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-cyan-300" aria-hidden="true" data-id="element-130" />
                      <span data-id="element-131">{item}</span>
                    </li>)}
                </ul>
              </div>

              <p className="mx-auto mb-6 max-w-2xl text-lg font-semibold leading-relaxed text-white md:text-xl" data-id="element-132">
                Al continuar al checkout, verás el precio convertido a la moneda
                de tu país y podrás completar tu compra de forma segura.
              </p>
              <a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-xl items-center justify-center gap-2 rounded-xl bg-cyan-400 px-6 py-5 text-lg font-extrabold text-stone-950 shadow-[0_6px_0_rgb(8,145,178)] transition hover:translate-y-0.5 hover:bg-cyan-300 hover:shadow-[0_3px_0_rgb(8,145,178)] focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan-200" data-id="element-133">
                OBTENER LA GUÍA MAESTRA POR US$27
                <ArrowRight className="h-5 w-5" aria-hidden="true" data-id="element-134" />
              </a>
              <div className="mt-6 flex items-center justify-center gap-2 text-sm text-stone-400" data-id="element-135">
                <ShieldCheck className="h-4 w-4" aria-hidden="true" data-id="element-136" />
                Pago seguro y acceso digital inmediato
              </div>
            </div>
          </div>
        </section>

        <section className="bg-stone-50 px-4 py-16 md:py-20" data-id="element-137">
          <div className="mx-auto max-w-3xl" data-id="element-138">
            <h2 className="mb-10 text-center text-3xl font-bold text-stone-950" data-id="element-139">
              Preguntas frecuentes
            </h2>
            <div className="space-y-5" data-id="element-140">
              {[['¿En qué formato recibo la guía?', 'Recibirás acceso a un producto digital que puedes consultar desde ordenador, tableta o teléfono.'], ['¿Necesito conocimientos técnicos previos?', 'No. La guía explica los conceptos desde cero y te ayuda a identificar cuándo una tarea debe ser realizada o revisada por un profesional certificado.'], ['¿Para qué tipo de vehículo sirve?', 'El método se puede adaptar a furgonetas, minibuses y vehículos de mayor tamaño. Las medidas y decisiones finales deben ajustarse siempre a tu vehículo.'], ['¿La guía sustituye la normativa o una certificación?', 'No. Las reglas varían por país y localidad. Verifica siempre los requisitos vigentes y recurre a profesionales certificados para gas, electricidad, homologación y cualquier intervención de seguridad.'], ['¿Puedo usarla si ya empecé el proyecto?', 'Sí. Las partes están organizadas por fases, por lo que puedes revisarlas desde el punto en el que te encuentras.']].map(([question, answer]) => <article key={question} className="rounded-2xl border border-stone-200 bg-white p-6" data-id="element-141">
                  <h3 className="mb-2 text-lg font-bold text-stone-950" data-id="element-142">
                    {question}
                  </h3>
                  <p className="leading-relaxed text-stone-700" data-id="element-143">{answer}</p>
                </article>)}
            </div>
          </div>
        </section>

        <section className="bg-emerald-950 px-4 py-16 text-emerald-50 md:py-20" data-id="element-144">
          <div className="mx-auto max-w-3xl text-center" data-id="element-145">
            <ShieldCheck className="mx-auto mb-5 h-16 w-16 text-emerald-300" aria-hidden="true" data-id="element-146" />
            <h2 className="mb-5 text-3xl font-bold text-white md:text-4xl" data-id="element-147">
              Garantía de 7 días
            </h2>
            <p className="mb-6 text-lg leading-relaxed" data-id="element-148">
              Revisa la guía durante una semana. Si no te ayuda a organizar
              mejor tu proyecto, podrás solicitar la devolución del 100% de tu
              compra.
            </p>
            <p className="text-xl font-bold text-white" data-id="element-149">
              Compra con tranquilidad por US$27.
            </p>
          </div>
        </section>
      </main>

      <footer className="bg-stone-950 px-4 py-12 text-center text-sm text-stone-400" data-id="element-150">
        <div className="mx-auto max-w-4xl space-y-5" data-id="element-151">
          <div className="flex items-center justify-center gap-2 text-stone-300" data-id="element-152">
            <Download className="h-5 w-5" aria-hidden="true" data-id="element-153" />
            <span className="font-medium" data-id="element-154">
              PRODUCTO DIGITAL · ACCESO INMEDIATO · US$27
            </span>
          </div>
          <p data-id="element-155">
            Guía Maestra de Camperización Completa. Todos los derechos
            reservados.
          </p>
          <p className="mx-auto max-w-2xl text-xs leading-relaxed text-stone-500" data-id="element-156">
            Esta guía ofrece información general con fines educativos. Comprueba
            la normativa aplicable en tu localidad y consulta siempre a
            profesionales certificados para instalaciones y modificaciones que
            puedan afectar la seguridad.
          </p>
        </div>
      </footer>
    </div>;
}
function initializeMetaPixel() {
  const metaWindow = window as MetaPixelWindow;
  if (metaWindow.fbq) {
    metaWindow.fbq('init', '1649256849507186');
    metaWindow.fbq('track', 'PageView');
    return;
  }
  const fbq: MetaPixelFunction = (...args) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue?.push(args);
  };
  fbq.queue = [];
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  metaWindow.fbq = fbq;
  metaWindow._fbq = fbq;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.dataset.metaPixel = '1649256849507186';
  document.head.appendChild(script);
  fbq('init', '1649256849507186');
  fbq('track', 'PageView');
}